import api from "@/api";

const getOrganizations = function(params = {}) {
  return api.get("/organizations", {
    params: params
  });
};

const getMyOrganizations = function() {
  return api.get("/user/organizations");
};

const getStats = function(id, params = {}) {
  return api.get(`/organizations/${id}/stats`, {
    params: params
  });
};

const getLogentry = function(id, params = {}) {
  return api.get(`/organizations/${id}/logentries`, {
    params: params
  });
};

const getLogentryXmlReport = function(id, params = {}) {
  return api.post(`/organizations/${id}/logentries/xls`, {}, params);
};

const getLogentryXmlClientReport = function(id, params = {}) {
  return api.post(`/organizations/${id}/logentries/client-xls`, {}, params);
};

const updateOrganization = function(org_id, params) {
  return api.patch(`/organizations/${org_id}`, params);
};

const getOrganizationsMembers = function(org_id, params = {}) {
  return api.get(`/organizations/${org_id}/members`, { params });
};

const inviteMember = function(org_id, params={}) {
  return api.post(`/organizations/${org_id}/members`, params)
};

const joinMember = function(org_id, params={}) {
  return api.post(`/organizations/${org_id}/members/join`, params)
};

const deleteMember = function(org_id, member_id) {
  return api.delete(`/organizations/${org_id}/members/${member_id}`)
};
const sendTerminalsCommand = function(id, command) {
  return api.post(`/organizations/${id}/terminals/${command}`);
};

export default {
  getOrganizations,
  getMyOrganizations,
  getStats,
  getLogentry,
  getLogentryXmlReport,
  getLogentryXmlClientReport,
  updateOrganization,

  getOrganizationsMembers,
  inviteMember,
  joinMember,
  deleteMember,

  sendTerminalsCommand
};
